import React from 'react';
import { DefaultValues, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { Form } from '@/components/ui/form';

import { ICheckList, checkListSchema } from './schema';
import CheckListFormView from './view';

interface IProps {
  defaultValues?: DefaultValues<ICheckList>;
  onSubmit: SubmitHandler<ICheckList>;
  submitText?: string;
}

const CheckListForm: React.FC<IProps> = ({
  defaultValues,
  onSubmit,
  submitText,
}) => {
  const form = useForm<ICheckList>({
    defaultValues: defaultValues ?? { name: '', steps: [] },
    resolver: zodResolver(checkListSchema),
  });

  return (
    <Form {...form}>
      <CheckListFormView
        control={form.control}
        onUndo={() => form.reset()}
        showUndo={!!defaultValues}
        onSubmit={form.handleSubmit(onSubmit)}
        submitText={submitText}
      />
    </Form>
  );
};

export default CheckListForm;
